import type { Guid, LvfSubmissionChannel } from "@kiraah-shared/common";
import type { IEntityDocumentStatusBaseInfo } from "@kiraah-shared/common";

export interface IMobileVoicePurchaseRequestSubmitTranscriptRequest {
  MissionUid: Guid;
  RawText: string;
  SessionUid?: Guid | null;
}

export interface IMobileAiVoicePurchaseRequestSession {
  Uid: Guid;
  MissionUid: Guid;
  AuthorUid: Guid;
  RawText: string;
  Status: number;
  PurchaseRequestUid?: Guid | null;
  GeneratedPurchaseRequest?: IMobileVoicePurchaseRequestResult | null;
}

export enum MobileVoicePurchaseRequestSessionStatus {
  Unknown = 0,
  TranscriptSaved = 1,
  PurchaseRequestDraft = 2,
  PurchaseRequestFinalized = 3,
  SentToSuppliers = 4,
}

export interface IMobileVoicePurchaseRequestLine {
  ProductUid?: Guid | null;
  Label: string;
  UnitPrice: number;
  /** Unit of measure from dictée (e.g. sac, m²). */
  UnitLabel?: string | null;
  Quantity: number;
  LineTotal: number;
}

export interface IMobileVoicePurchaseRequestResult {
  TranscriptUid: Guid;
  MissionUid: Guid;
  PurchaseRequestUid?: Guid | null;
  ThirdPartUid?: Guid | null;
  CompanyName: string;
  CompanyAddress?: string | null;
  VATPercentage: number;
  TotalHT: number;
  VATAmount: number;
  TotalTTC: number;
  Lines: IMobileVoicePurchaseRequestLine[];
}

export interface IMobileVoicePurchaseRequestUpdateRequest {
  Lines: IMobileVoicePurchaseRequestLine[];
}

/** Sales purchase request shell / procurement slice (wizard). */
export interface IMobileVoicePurchaseRequestShellInfo extends IEntityDocumentStatusBaseInfo {
  SubmissionScheduledAt?: string | Date | null;
  SubmissionScheduledAtString?: string | null;
}

export interface IMobileVoicePurchaseRequestSupplierQuoteInfo extends IEntityDocumentStatusBaseInfo {
  PurchaseRequestUid?: Guid;
  SupplierUid?: Guid;
  SupplierContactUid?: Guid;
  SubmissionChannel?: LvfSubmissionChannel;
  IsEmitted?: boolean;
}

export interface IMobileVoicePurchaseRequestAddSupplierPayload {
  PurchaseRequestUid: Guid;
  SupplierUid: Guid;
  SupplierContactUid: Guid;
  SubmissionChannel: LvfSubmissionChannel;
}

export interface IMobileVoicePurchaseRequestProviderListItem {
  Uid: Guid;
  ThirdPartUid?: Guid;
  Label: string;
  Email?: string | null;
  EnterpriseCommercialName?: string | null;
  EnterpriseLogoUrl?: string | null;
}

/** Persisted supplier contact selection for Sales submission. */
export interface IMobileVoicePurchaseRequestProviderSelection {
  Uid: Guid;
  ThirdPartUid?: Guid;
  Email?: string | null;
}

export interface IMobileVoicePurchaseRequestSubmitContactsResult {
  ContactsSubmitted: number;
  ContactsFailed: number;
  IsScheduledDeferred: boolean;
  SubmissionScheduledAt?: string | null;
}
